import React from 'react';

const About: React.FC = () => {
  const expertise = [
    {
      category: 'AWS Cloud',
      skills: ['Compute', 'Serverless', 'Containerization', 'IAM', 'Networking', 'Security', 'Monitoring', 'Cost Management', 'Migration', 'Compliance', 'Well-Architected Framework', 'CloudFormation', 'Terraform'],
      level: 'Expert'
    },
    {
      category: 'Infrastructure as Code',
      skills: ['Terraform', 'CloudFormation', 'OpenTofu', 'Ansible', 'Compliance as Code', 'Security as Code'],
      level: 'Expert'
    },
    {
      category: 'CI/CD',
      skills: ['Jenkins', 'GitHub Actions', 'CodePipeline','Designing CI/CD Pipelines', 'CI/CD Best Practices', 'Scaling CI/CD'],
      level: 'Expert'
    },
    {
      category: 'DevOps',
      skills: ['Three ways', 'CALMS', 'DevSecOps', 'SRE', 'Chaos Engineering', 'Observability', 'Monitoring', 'Logging', 'Alerting', 'Incident Management', 'On-call', 'Blameless Postmortems', 'Value Stream Mapping', 'Lean', 'Kanban', 'Scrum', 'Agile', 'Lean Startup', 'Design Thinking'],
      level: 'Expert'
    },
    {
      category: 'Technical Expertise',
      skills: ['Linux', 'Security', 'Databases', 'Web Servers', 'Containers', 'Docker', 'Serverless', 'Monitoring', 'Logging', 'Alerting', 'Incident Management', 'On-call', 'Blameless Postmortems', 'Value Stream Mapping', 'Lean', 'Kanban', 'Scrum', 'Agile', 'Lean Startup', 'Design Thinking'],

      level: 'Expert'
    },
    {
      category: 'Developer Advocacy',
      skills: ['Public speaking', 'Content creation', 'Community building', 'Podcasting', 'YouTube', 'Blogging', 'Social media', 'Mentoring', 'Coaching', 'Training', 'Workshops', 'Webinars', 'Conferences', 'Meetups', 'Hackathons', 'Code reviews', 'Pair programming', 'Open Source'],
      
      level: 'Expert'
    }
  ];

  const achievements = [
    {
      title: 'Docker Captain',
      year: '2024-',
      description: 'Recognized Docker expert and community leader as third person in Poland'
    },
    {
      title: 'AWS Community Builder',
      year: '2021-',
      description: 'Contributing to AWS community growth'
    },
    {
      title: 'DevOps Institute Ambassador',
      year: '2021-',
      description: 'Promoting DevOps best practices globally'
    },
    {
      title: 'CD Foundation Ambassador',
      year: '2022-',
      description: 'Advocating for Continuous Delivery Foundation'
    }
  ];

  return (
    <div className="page about">
      <div className="container">
        <section className="hero-section">
          <img src="/images/20241202_132057.jpg" alt="Pawel Piwosz" className="profile-image" />
          <h1>About Me</h1>
          <p className="lead">DevOps Manager, Coach and Cloud Architecture Expert</p>
          <p>Almost 30 years of experience building and scaling infrastructure solutions</p>
        </section>

        <section className="expertise-section">
          <h2>Technical Expertise</h2>
          <div className="expertise-grid">
            {expertise.map((area) => (
              <div key={area.category} className="expertise-card">
                <h3>{area.category}</h3>
                <div className="skills-pills">
                  {area.skills.map(skill => (
                    <span key={skill} className="skill-pill">{skill}</span>
                  ))}
                </div>
                <span className="level-badge">{area.level}</span>
              </div>
            ))}
          </div>
        </section>

        <section className="achievements-section">
          <h2>Recognition & Achievements</h2>
          <div className="achievements-timeline">
            {achievements.map((achievement) => (
              <div key={achievement.title} className="achievement-card">
                <span className="year">{achievement.year}</span>
                <h3>{achievement.title}</h3>
                <p>{achievement.description}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="current-focus">
          <h2>Current Focus</h2>
          <div className="focus-areas">
            <div className="focus-card">
              <h3>Cloud Architecture</h3>
              <p>Designing scalable and resilient cloud solutions</p>
            </div>
            <div className="focus-card">
              <h3>DevOps Coaching</h3>
              <p>Mentoring teams in DevOps practices and culture</p>
            </div>
            <div className="focus-card">
              <h3>Community Building</h3>
              <p>Growing tech communities through speaking and content creation</p>
            </div>
            <div className="focus-card">
              <h3>Serverless</h3>
              <p>Advocating for Serverless approach and best practices</p>
            </div>
            <div className="focus-card">
              <h3>Infrastructure as Code</h3>
              <p>Teaching community how important is the proper design of infrastructure and processes related to it</p>
            </div>
            <div className="focus-card">
              <h3>CI/CD</h3>
              <p>If DevOps is the heart of your Organization, then Value Stream Management should be the brain and CI/CD the bloodstream.</p>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default About;